import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Mtrmb { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '流水號 (MB001) 不可空白'}) 
    @MaxLength(6,{message: '流水號 (MB001) 資料太長'})
    MB001: string = '';            // 流水號 6 GetTableKey (名片簿)

    @MaxLength(10,{message: '擁有者 (MB002) 資料太長'})
    MB002: string = 'JACK';            // 擁有者 10 [DEF:"JACK"]   Default: UserID

    @MaxLength(30,{message: '姓名 (MB003) 資料太長'})
    MB003: string = '';            // 姓名 30 

    @MaxLength(10,{message: '職務 (MB004) 資料太長'})
    MB004: string = '';            // 職務 10 

    @MaxLength(1,{message: '性別 (MB005) 資料太長'})
    MB005: string = '1';            // 性別 1 [DEF:"1"] {{1.男2.女3.公司}}

    @MaxLength(60,{message: '公司 (MB006) 資料太長'})
    MB006: string = '';            // 公司 60 

    @MaxLength(20,{message: '個人電話(一) (MB007) 資料太長'})
    MB007: string = '';            // 個人電話(一) 20 

    @MaxLength(20,{message: '個人電話(二) (MB008) 資料太長'})
    MB008: string = '';            // 個人電話(二) 20 

    @MaxLength(20,{message: '手機 (MB009) 資料太長'})
    MB009: string = '';            // 手機 20 

    @MaxLength(20,{message: '個人傳真號碼 (MB010) 資料太長'})
    MB010: string = '';            // 個人傳真號碼 20 

    @MaxLength(50,{message: '個人E-MAIL (MB011) 資料太長'})
    MB011: string = '';            // 個人E-MAIL 50 

    @MaxLength(6,{message: '部門別 (MB012) 資料太長'})
    MB012: string = '';            // 部門別 6 

    @MaxLength(6,{message: '通路別 (MB013) 資料太長'})
    MB013: string = '';            // 通路別 6 

    @MaxLength(6,{message: '地區別 (MB014) 資料太長'})
    MB014: string = '';            // 地區別 6 

    @MaxLength(8,{message: '生日 (MB015) 資料太長'})
    MB015: string = '';            // 生日 8 [FORMATE:YMD]

    @MaxLength(72,{message: '個人地址 (MB016) 資料太長'})
    MB016: string = '';            // 個人地址 72 

    @MaxLength(6,{message: '個人郵遞區號 (MB017) 資料太長'})
    MB017: string = '';            // 個人郵遞區號 6 

    @MaxLength(2048,{message: '個人網址 (MB018) 資料太長'})
    MB018: string = '';            // 個人網址 2048 

    @MaxLength(2048,{message: '照片網址 (MB019) 資料太長'})
    MB019: string = '';            // 照片網址 2048 

    @MaxLength(255,{message: '備註 (MB020) 資料太長'})
    MB020: string = '';            // 備註 255 

    @MaxLength(72,{message: '公司地址 (MB021) 資料太長'})
    MB021: string = '';            // 公司地址 72 

    @MaxLength(6,{message: '公司郵遞區號 (MB022) 資料太長'})
    MB022: string = '';            // 公司郵遞區號 6 

    @MaxLength(20,{message: '公司電話(一) (MB023) 資料太長'})
    MB023: string = '';            // 公司電話(一) 20 

    @MaxLength(20,{message: '公司傳真號碼 (MB024) 資料太長'})
    MB024: string = '';            // 公司傳真號碼 20 

    @MaxLength(50,{message: '公司E-MAIL (MB025) 資料太長'})
    MB025: string = '';            // 公司E-MAIL 50 

    @MaxLength(20,{message: '暱稱 (MB026) 資料太長'})
    MB026: string = '';            // 暱稱 20 

    @MaxLength(10,{message: '客戶代號 (MB027) 資料太長'})
    MB027: string = '';            // 客戶代號 10 

    @MaxLength(10,{message: '廠商代號 (MB028) 資料太長'})
    MB028: string = '';            // 廠商代號 10 

    @MaxLength(20,{message: '部門名稱 (MB029) 資料太長'})
    MB029: string = '';            // 部門名稱 20 

    MB030: string = '';            // 附註 0 


}
